import { routes, RecurringPlansStatsResponse } from "@/services/recurringPlans";
import useSWR from "swr";
import { fetcherV2 } from "@gogive/services";

export type RecurringStatsFilters = {
  planStatus?: string;
  planInterval?: string;
  campaignId?: number;
  search?: string;
  startDate?: string;
  endDate?: string;
};

function buildStatsParams(
  filters: RecurringStatsFilters
): Record<string, string | number> {
  const params: Record<string, string | number> = {
    page: 0,
    limit: 1,
    sortBy: "createdAt",
    sortDirection: "DESC",
  };
  if (filters.planStatus) params.planStatus = filters.planStatus;
  if (filters.planInterval) params.planInterval = filters.planInterval;
  if (filters.campaignId != null) params.campaignId = filters.campaignId;
  if (filters.search) params.search = filters.search;
  if (filters.startDate) params.startDate = filters.startDate;
  if (filters.endDate) params.endDate = filters.endDate;
  return params;
}

export function useRecurringPlansStats(filters: RecurringStatsFilters = {}) {
  const params = buildStatsParams(filters);

  const { data, error } = useSWR(
    [routes.recurringPlansStats, params],
    fetcherV2<RecurringPlansStatsResponse>,
    {
      revalidateIfStale: true,
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      suspense: false,
      shouldRetryOnError: false,
    }
  );

  return {
    stats: data,
    isLoading: !error && !data,
    isError: error,
  };
}
